import essLocalApi from '../axios/esspLocalApi';
import essApi from '../axios/essApi'

class Authorization {
    constructor() { }

    logout() { }

    async login(payload) {
        return Promise.resolve(essLocalApi.get(`users.json`));
    }

    async loginWithEmail(payload) {
        return Promise.resolve(essApi.post(`users/login`, payload));
    }

    async loginWithSSO(payload, token = null) {
        return Promise.resolve(essApi.post(`users/ssologin`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }));
    }
}

export default Authorization;